import { BMJ_FORMATTED_NAME, CBINSIGHTS_FORMATTED_NAME, NEJM_FORMATTED_NAME, PITCHBOOK_FORMATTED_NAME, STATISTA_FORMATTED_NAME, WILEY_FORMATTED_NAME, MIDPAGE_FORMATTED_NAME, VISUALDX_FORMATTED_NAME, } from '#pplx/frontend/branded-sources/consts.js';
/**
 * Returns the formatted label for a premium data source type
 */
export const getPremiumDataSourceTypeLabel = (sourceId) => {
    switch (sourceId) {
        case 'wiley_mcp_cashmere':
            return WILEY_FORMATTED_NAME;
        case 'cbinsights_mcp_cashmere':
            return CBINSIGHTS_FORMATTED_NAME;
        case 'pitchbook_mcp_cashmere':
            return PITCHBOOK_FORMATTED_NAME;
        case 'statista_mcp_cashmere':
            return STATISTA_FORMATTED_NAME;
        case 'midpage':
            return MIDPAGE_FORMATTED_NAME;
        case 'visualdx':
            return VISUALDX_FORMATTED_NAME;
        case 'nejm':
            return NEJM_FORMATTED_NAME;
        case 'bmj':
            return BMJ_FORMATTED_NAME;
        default:
            return sourceId;
    }
};
//# sourceMappingURL=getPremiumDataSourceTypeLabel.js.map